

<div class="footer">
    <div class="buttons-container">
        <!-- Privacy policy -->
        <button 
            data-test="button_privacyPolicy"
            class="button-custom custom-font-family font-size" 
            (click)="openMarkdownFile(markdownFiles.privacyPolicy)">
                {{languageService.Strings.footerStrings.button_privacyPolicy}}
        </button>
        <!-- Data protection policy -->
        <button 
            data-test="button_dataProtectionPolicy"
            class="button-custom custom-font-family font-size" 
            (click)="openMarkdownFile(markdownFiles.dataProtectionPolicy)">
                {{languageService.Strings.footerStrings.button_dataProtectionPolicy}}
        </button>
        <!-- Cookie policy -->
        <button 
            data-test="button_cookiePolicy"
            class="button-custom custom-font-family font-size" 
            (click)="openMarkdownFile(markdownFiles.cookiePolicy)">
                {{languageService.Strings.footerStrings.button_cookiePolicy}}
        </button>
        <!-- Quality policy -->
        <button 
            data-test="button_qualityPolicy"
            class="button-custom custom-font-family font-size" 
            (click)="openMarkdownFile(markdownFiles.qualityPolicy)">
                {{languageService.Strings.footerStrings.button_qualityPolicy}}
        </button>
        <!-- Ethical chanel -->
        <button 
            data-test="button_ethicalChannel"
            class="button-custom custom-font-family font-size" 
            (click)="openEthicalChannel()">
                {{languageService.Strings.footerStrings.button_ethicalChannel}}
        </button>
        <!-- Information security policy-->
        <button 
            data-test="button_informationSecurityPolicy"
            class="button-custom custom-font-family font-size" 
            (click)="openMarkdownFile(markdownFiles.informationSecurityPolicy)">
                {{languageService.Strings.footerStrings.button_informationSecurityPolicy}}
        </button>
        <!-- Information security policy-->
        <button 
            data-test="button_informationSecurityPolicy"
            class="button-custom custom-font-family font-size" 
            (click)="openMarkdownFile(markdownFiles.informationSecurityPolicyENS)">
                {{languageService.Strings.footerStrings.button_informationSecurityPolicyENS}}
        </button>
        <!-- Transparency portal-->
        <button 
            data-test="button_transparencyPortal"
            class="button-custom custom-font-family font-size" 
            (click)="openTransparencyPortal()">
                {{languageService.Strings.footerStrings.button_transparencyPortal}}
        </button>
    </div>
</div>